import { useLocation } from "react-router-dom"
import { useState, useEffect } from "react"

import List from "./list.js"
import Info from "./info.js"

export default function Root(props) {
	const [query, setQuery] = useState({})

	let location = useLocation()
	useEffect(() => {
		const urlSearchParams = new URLSearchParams(location.search)
		const q = Object.fromEntries(urlSearchParams.entries())
		setQuery(q)
	}, [location])

	return <div>
		<List style={{ display: query.id ? "none" : "flex" }} />
		{query.id && <Info id={query.id} />}
	</div>
}
